import { BlockModule } from './common'

new BlockModule({
    selector: '.block-hero-banner',
})
